import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 1 }

import {
  ref,
  toRefs,
  computed,
  watch,
  withDefaults
} from 'vue'
import apiHjexUseCase from '@/usecase/apiHjexUseCase'
import returnUrlPrams from '@/utils/helpers/returnUrlPrams'
import
vSelect,
{
  VueSelectProps
} from 'vue-select'
import { useIntersectionObserver } from '@vueuse/core'

interface IPropsSelectAsync extends Partial<VueSelectProps> {
  endpoint: string
  fieldValue?: string
  fieldLabel?: (item: any) => string
  searchFields?: Array<string>
  modelValue?: any
  searchCustom?: Array<any>
  id?: string
  classname?: string
  selectable?: (item: any) => boolean
  inputId: string
  placeholder: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SelectAsyncHjex',
  props: {
    endpoint: { default: '' },
    fieldValue: { default: 'Id' },
    fieldLabel: { type: Function, default: () => 'Name' },
    searchFields: { default: () => [] },
    modelValue: { default: null },
    searchCustom: { default: () => [] },
    id: { default: '' },
    classname: { default: '' },
    selectable: { type: Function, default: () => true },
    inputId: { default: '' },
    placeholder: { default: 'Pilih' }
  },
  emits: ["update:modelValue", "change", "search:focus"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', val: any): void
  (e: 'change', val: any): void
  (e: 'search:focus'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { endpoint: string, fieldValue: string, fieldLabel: (item: any) => string, searchFields: Array<string>, modelValue: any, searchCustom: Array<any>, id: string, classname: string, selectable: (item: any) => boolean, inputId: string, placeholder: string }





const {
  endpoint,
  fieldLabel,
  modelValue,
  inputId,
  placeholder,
  clearable,
  disabled,
  fieldValue,
  searchFields,
  searchCustom,
  id,
  selectable,
  classname
} = toRefs(props)

const isLoading = ref(false)
const options = ref([]) as any
const inputSearch = ref('')

const valueSelect = computed({
  get: () => modelValue?.value,
  set: (v) => {
    emit('update:modelValue', v)
  }
})
const hasNextPage = ref(false)
const load = ref(null) as unknown as HTMLElement
const targetIsVisible = ref(false)
const pagination = {
  count: 0,
  pageNumber: 1,
  pageSize: 10,
  limit: 0
}

const selectableRow = (row: any) => selectable?.value(row)

// eslint-disable-next-line consistent-return
// const selectableRule = (val: any) => {
//   console.log('vall=>', val)
//   if (selectableParams.value.length > 0) {
//     if (lowerCase(selectableParams.value[1]) === 'equal') {
//       if (val[`${selectableParams.value[0]}`] === selectableParams.value[2]) {
//         return true
//       }
//       return false
//     }
//     if (lowerCase(selectableParams.value[1]) === 'notequal') {
//       if (val[`${selectableParams.value[0]}`] !== selectableParams.value[2]) {
//         return true
//       }
//       return false
//     }
//   }
//   return true
// }

const getData = async () => {
  try {
    isLoading.value = true
    const { result, error, count, pagenumber } = await apiHjexUseCase.get(`${endpoint.value}${returnUrlPrams({
      search: inputSearch.value,
      filterField: searchFields.value,
      custom: searchCustom.value,
      pageNumber: pagination.pageNumber
    })}`)
    if (!error) {
      if (pagenumber === 1) {
        pagination.limit = 0
        pagination.count = 0
        options.value = []
        // console.log('optionsreset', [inputSearch.value, options.value])
      }
      pagination.limit = count
      pagination.count += result.length
      // console.log([pagination.limit, pagination.count])
      if (pagination.count < pagination.limit) {
        hasNextPage.value = true
        pagination.pageNumber += 1
      } else {
        hasNextPage.value = false
      }

      // console.log('asadad', hasNextPage.value)
      // eslint-disable-next-line array-callback-return
      result.map((item: any) => {
        const data = {
          ...item,
          label: typeof fieldLabel.value === 'function' ? fieldLabel.value(item) : item[fieldLabel.value],
          value: item[fieldValue.value]
        }
        options.value.push(data)
      })
      console.log('options', options.value)
    }
    isLoading.value = false
  } catch (err) {
    isLoading.value = false
  }
}

const onOpen = () => {
  // if (pagination.count === 0) {
  //   getData()
  // }
  emit('search:focus')
}

const onSearch = (val: any) => {
  // console.log('valSearch', val)
  if (val !== inputSearch.value) {
    pagination.pageNumber = 1
    options.value = []
    hasNextPage.value = false
    inputSearch.value = val
    if (inputSearch.value.length === 0 || inputSearch.value.length > 2) {
      getData()
    }
  }
}

const { stop } = useIntersectionObserver(load, ([{ isIntersecting }], observerElement) => {
  targetIsVisible.value = isIntersecting

  const documentId = document.querySelector('#load') as HTMLElement

  const ul = documentId.offsetParent as any
  const xxxx = documentId.offsetParent?.scrollTop
  ul.scrollTop = xxxx
  // console.log('xxx', [xxxx, ul])
  if (targetIsVisible.value) {
    // pagination.pageNumber += 1
    // searchCustom.value = []
    // searchCustom.value.push(['pageNumber', '=', pagination.pageNumber])
    getData()
  }
})

// const onSearch = debounce(getData, 500)

const optionSelected = (select: any) => {
  // console.log('selec', select)
  emit('change', select)
}

watch(valueSelect, (val: any) => {
  console.log('val', val)
  if (!val) {
    emit('change', val)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(vSelect), {
      class: _normalizeClass(`select-default ${_unref(classname)}`),
      inputId: _unref(inputId),
      placeholder: _unref(placeholder),
      clearable: _unref(clearable),
      id: _unref(id),
      disabled: _unref(disabled),
      options: _unref(options),
      modelValue: _unref(valueSelect),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(valueSelect) ? (valueSelect).value = $event : null)),
      onOpen: onOpen,
      onSearch: onSearch,
      selectable: selectableRow,
      "onOption:selected": optionSelected,
      "onOption:deselecting": optionSelected,
      loading: isLoading.value,
      autofocus: false
    }, {
      "list-footer": _withCtx(() => [
        (hasNextPage.value)
          ? (_openBlock(), _createElementBlock("li", {
              key: 0,
              ref_key: "load",
              ref: load,
              id: "load",
              class: "loader"
            }, " Sedang memuat... ", 512))
          : _createCommentVNode("", true)
      ]),
      "no-options": _withCtx(({ searching, loading }) => [
        searching
          ? (_openBlock(), _createElementBlock("p", _hoisted_1, " Tidak ada data ditemukan. "))
          : _createCommentVNode("", true),
        loading
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, " Tidak ada data ditemukan. "))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["class", "inputId", "placeholder", "clearable", "id", "disabled", "options", "modelValue", "loading"])
  ]))
}
}

})